import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    flex: 0.2,
    justifyContent: 'end',
  },
}));
